import _ from "lodash";
import { SumOtherDebtAmount } from "../../../functions/Balance/sumValueBalance";

export const calPropertyLocalOption = (localOption, item) => {
  return Math.abs(item?.amount);
};

export const calDebtLocalOption = (localOption, item) => {
  if (localOption?.label === "หนี้นอกระบบ (รายวัน)") {
    return +item?.start_amount;
  }
  return +item?.unpaid_amount;
};

export const calIncomeInterestLocalOption = (localOption, item) => {
  return +item?.interest_peryear;
};

export const calIncomeInterestOtherOption = (localOption, item) => {
  return +item?.other_income_peryear;
};

export const calExpenseFixedOption = (localOption, item) => {
  return +item?.insurance_fund;
};

export const calExpenseVariableOption = (localOption, item) => {
  return +item?.pay_peryear;
};

export const calExpenseVariableMonthOption = (localOption, item) => {
  return +item?.pay_permonth;
};

export const getBalanceItems = (
  balanceData,
  mergeOptions,
  calLocalOption,
  calLocalMonthOption
) => {
  let newPropertyItems = [];

  for (const mergeOption of mergeOptions) {
    let localProperty = {
      label: mergeOption.label,
      items: [],
      sum_total: 0,
      icon: mergeOption.icon,
    };

    for (const option of mergeOption.options) {
      let localOption = {
        label: option.label,
        amount_per_year: 0,
        amount_per_month: 0,
        returns: 0,
        reward_amount_per_year: 0,
      };

      if (balanceData?.[mergeOption?.key]?.length > 0) {
        for (const balanceDataPropertyItem of balanceData?.[mergeOption?.key]) {
          const balanceDataPropertyItemKeys = Object.keys(
            balanceDataPropertyItem
          );

          if (
            [
              "interest_peryear_list",
              "other_income_list",
              "expenses_invest_saving_list",
              "expenses_variable_list",
            ].includes(mergeOption.key) &&
            balanceDataPropertyItem?.[mergeOption?.key_option] === option.value
          ) {
            if (calLocalMonthOption) {
              localOption.amount_per_month += calLocalMonthOption(
                localOption,
                balanceDataPropertyItem
              );
            } else if (mergeOption?.calLocalMonthOption) {
              localOption.amount_per_month += mergeOption?.calLocalMonthOption(
                localOption,
                balanceDataPropertyItem
              );
            }

            if (mergeOption.calLocalOption) {
              localOption.amount_per_year += mergeOption.calLocalOption(
                localOption,
                balanceDataPropertyItem
              );
            } else {
              localOption.amount_per_year += calLocalOption(
                localOption,
                balanceDataPropertyItem
              );
            }
          } else {
            for (const balanceDataPropertyItemKey of balanceDataPropertyItemKeys) {
              if (
                _.isArray(
                  balanceDataPropertyItem[balanceDataPropertyItemKey]
                ) &&
                balanceDataPropertyItem?.[mergeOption?.key_option] ===
                  option.value
              ) {
                let left = 0;
                let right = 0;
                for (const item of balanceDataPropertyItem[
                  balanceDataPropertyItemKey
                ]) {
                  if (
                    ["property_invest_list"].includes(mergeOption?.key) &&
                    item?.reward_amount_per_year
                  ) {
                    left += item?.amount * item?.reward_amount_per_year;
                    right += item?.amount;
                  }

                  if (calLocalMonthOption) {
                    localOption.amount_per_month += calLocalMonthOption(
                      localOption,
                      item
                    );
                  } else if (mergeOption.calLocalMonthOption) {
                    localOption.amount_per_month +=
                      mergeOption.calLocalMonthOption(localOption, item);
                  }

                  if (mergeOption?.calLocalOption) {
                    localOption.amount_per_year += mergeOption.calLocalOption(
                      localOption,
                      item
                    );
                  } else {
                    if (mergeOption?.label !== "สินทรัพย์ใช้ส่วนตัว") {
                      localOption.amount_per_year += calLocalOption(
                        localOption,
                        item
                      );
                    }

                    if (mergeOption?.label === "สินทรัพย์ใช้ส่วนตัว") {
                      localOption.amount_per_year += calLocalOption(
                        localOption,
                        item
                      );
                    }
                  }
                }
                localOption.reward_amount_per_year = left / right;
              }
            }
          }
        }
      }

      localProperty.items.push(localOption);
    }

    if (mergeOption?.label === "ค่าใช้จ่ายคงที่") {
      for (let index = 0; index < localProperty?.items?.length; index++) {
        if (localProperty?.items[index]?.label === "ค่าเบี้ยประกันชีวิตรายปี") {
          localProperty.items[index].amount_per_year =
            balanceData?.expenses_fixed_list
              ?.find(
                (item) =>
                  item?.options_expenses_fixed === "expenses_insuarant_life"
              )
              ?.expenses_insuarant_lifes?.reduce(
                (acc, cur) => acc + cur?.allowance_peryear,
                0
              );
        }

        if (
          localProperty?.items[index]?.label === "ค่าเบี้ยประกันอุบัติเหตุรายปี"
        ) {
          localProperty.items[index].amount_per_year =
            balanceData?.expenses_fixed_list
              ?.find(
                (item) =>
                  item?.options_expenses_fixed === "expenses_insuarant_accident"
              )
              ?.expenses_insuarant_accidents?.reduce(
                (acc, cur) => acc + cur?.allowance_peryear,
                0
              );
        }

        if (
          localProperty?.items[index]?.label === "ค่าเบี้ยประกันรถยนต์รายปี"
        ) {
          localProperty.items[index].amount_per_year =
            balanceData?.expenses_fixed_list
              ?.find(
                (item) =>
                  item?.options_expenses_fixed === "expenses_insuarant_car"
              )
              ?.expenses_insuarant_cars?.reduce(
                (acc, cur) => acc + cur?.allowance_peryear,
                0
              );
        }

        if (
          localProperty?.items[index]?.label === "ค่าเบี้ยประกันอัคคีภัยรายปี"
        ) {
          localProperty.items[index].amount_per_year =
            balanceData?.expenses_fixed_list
              ?.find(
                (item) =>
                  item?.options_expenses_fixed === "expenses_insuarant_fire"
              )
              ?.expenses_insuarant_fires?.reduce(
                (acc, cur) => acc + cur?.allowance_peryear,
                0
              );
        }

        if (localProperty?.items[index]?.label === "ค่าเบี้ยประกันบ้านรายปี") {
          localProperty.items[index].amount_per_year =
            balanceData?.expenses_fixed_list
              ?.find(
                (item) =>
                  item?.options_expenses_fixed === "expenses_insuarant_home"
              )
              ?.expenses_insuarant_homes?.reduce(
                (acc, cur) => acc + cur?.allowance_peryear,
                0
              );
        }
      }
    }

    if (mergeOption?.label === "สินทรัพย์เพื่อการลงทุน") {
      for (let index = 0; index < localProperty.items.length; index++) {
        if (localProperty.items[index].label === "มูลค่าเวนคืน") {
          localProperty.items[index].amount_per_year =
            balanceData?.expenses_fixed_list
              ?.find(
                (item) =>
                  item?.options_expenses_fixed === "expenses_insuarant_life"
              )
              ?.expenses_insuarant_lifes?.reduce(
                (acc, cur) => acc + cur?.insurance_policy_cash_surrender,
                0
              );
        }
      }
    }

    if (localProperty.label === "สินทรัพย์ใช้ส่วนตัว") {
      for (let index = 0; index < localProperty?.items?.length; index++) {
        const item = localProperty.items[index];
        if (item?.label === "อื่น ๆ") {
          localProperty.items[index].amount_per_year +=
            SumOtherDebtAmount(balanceData);
        }
      }
    }

    localProperty.sum_total = localProperty.items.reduce(
      (acc, cur) => acc + cur.amount_per_year,
      0
    );

    const createLastItem = {
      label: "รวม",
      amount_per_year: localProperty.sum_total,
      amount_per_month: 0,
      returns: "",
      reward_amount_per_year: 0,
    };

    let left = 0;
    let right = 0;
    for (const item of localProperty.items) {
      if (item?.label === "มูลค่าเวนคืน") {
        left += 0;
        right += 0;
      }

      if (item?.label !== "มูลค่าเวนคืน") {
        left += item?.amount_per_year * item?.reward_amount_per_year;
        right += item?.amount_per_year;
      }
    }

    createLastItem.reward_amount_per_year = left / right;

    localProperty.items.push(createLastItem);

    // cal returns
    for (const item of localProperty.items) {
      if (item?.label === "มูลค่าเวนคืน") {
        item.returns = 0;
      }
      if (item?.label !== "มูลค่าเวนคืน") {
        item.returns = (item.amount_per_year / localProperty.sum_total) * 100;
      }
    }
    newPropertyItems.push(localProperty);
  }

  return newPropertyItems;
};

export const getAllBalanceTotal = (balanceData, mergeOptions) => {
  let sum_total = 0;
  for (const mergeOption of mergeOptions) {
    const key = mergeOption.key;
    if (balanceData?.[key]?.length > 0) {
      for (const item of balanceData?.[key]) {
        const keys = Object.keys(item);
        for (const key of keys) {
          if (_.isArray(item[key])) {
            sum_total += item[key].reduce((acc, cur) => acc + cur.amount, 0);
          }
        }
      }
    }
  }
  return sum_total;
};

export const getAllPropertyTotal = (propertyItems = []) => {
  let sum_total = 0;
  for (const propertyItem of propertyItems) {
    sum_total += propertyItem.sum_total;
  }
  return sum_total;
};

export const mapStatus = (value) => {
  if (value === "good") {
    return "ยอดเยี่ยม";
  } else if (value === "normal") {
    return "พอใช้";
  } else if (value === "bad") {
    return "ปรับปรุง";
  } else if (value === "chance") {
    return "เพิ่มโอกาส";
  } else if (value === "no_data") {
    return "ไม่มีข้อมูล";
  }
};

export const mapIcon = (value) => {
  if (value === "bad") {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 91 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46.9969 87.7437C76.1656 87.7437 90.7437 68.1562 90.7437 43.9937C90.7437 19.8375 76.1656 0.25 46.9937 0.25C17.8281 0.25 3.25 19.8375 3.25 43.9969C3.25 68.1562 17.825 87.7437 46.9969 87.7437Z"
          fill="url(#paint0_radial_7859_64959)"
        />
        <path
          d="M46.9969 87.7437C76.1656 87.7437 90.7437 68.1562 90.7437 43.9937C90.7437 19.8375 76.1656 0.25 46.9937 0.25C17.8281 0.25 3.25 19.8375 3.25 43.9969C3.25 68.1562 17.825 87.7437 46.9969 87.7437Z"
          fill="url(#paint1_radial_7859_64959)"
        />
        <path
          d="M46.9969 87.7437C76.1656 87.7437 90.7437 68.1562 90.7437 43.9937C90.7437 19.8375 76.1656 0.25 46.9937 0.25C17.8281 0.25 3.25 19.8375 3.25 43.9969C3.25 68.1562 17.825 87.7437 46.9969 87.7437Z"
          fill="url(#paint2_radial_7859_64959)"
          fill-opacity="0.6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.6457 29.7749C15.4581 31.2264 12.8507 33.7068 11.2419 36.818C9.63314 39.9292 9.11631 43.4906 9.7744 46.9307C10.4325 50.3709 12.2273 53.4901 14.8708 55.7878C17.5143 58.0855 20.8531 59.4284 24.3514 59.601C27.8496 59.7735 31.3044 58.7657 34.1612 56.7393C37.0179 54.7129 39.111 51.7854 40.1044 48.4267C41.0979 45.0681 40.934 41.473 39.6392 38.2187C38.3444 34.9643 35.9937 32.2393 32.9645 30.4812C30.9424 31.1651 28.8209 31.5094 26.6863 31.4999C23.9125 31.5174 21.1683 30.9286 18.6457 29.7749Z"
          fill="url(#paint3_radial_7859_64959)"
        />
        <path
          d="M57.9375 59.625C65.704 59.625 72 53.329 72 45.5625C72 37.796 65.704 31.5 57.9375 31.5C50.171 31.5 43.875 37.796 43.875 45.5625C43.875 53.329 50.171 59.625 57.9375 59.625Z"
          fill="url(#paint4_radial_7859_64959)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.9694 27.8564C35.6569 29.5721 31.8976 31.5002 26.6882 31.5002C24.1331 31.515 21.601 31.0177 19.2413 30.0377C17.3671 32.1741 16.1842 34.8283 15.8485 37.6504C15.5128 40.4725 16.04 43.3301 17.3607 45.8466C18.6815 48.3631 20.7337 50.4203 23.2469 51.7472C25.7601 53.0741 28.6164 53.6084 31.4394 53.2796C34.2623 52.9508 36.9193 51.7744 39.0604 49.9054C41.2014 48.0365 42.7259 45.5626 43.4329 42.81C44.1399 40.0573 43.9963 37.155 43.021 34.4856C42.0457 31.8162 40.2845 29.5049 37.9694 27.8564ZM74.7601 30.0377C72.4004 31.0178 69.8683 31.515 67.3132 31.5002C62.1069 31.5002 58.3444 29.5721 56.0319 27.8564C53.7169 29.5049 51.9557 31.8162 50.9804 34.4856C50.005 37.155 49.8614 40.0573 50.5685 42.81C51.2755 45.5626 52.8 48.0365 54.941 49.9054C57.082 51.7744 59.7391 52.9508 62.562 53.2796C65.3849 53.6084 68.2412 53.0741 70.7545 51.7472C73.2677 50.4203 75.3199 48.3631 76.6406 45.8466C77.9614 43.3301 78.4886 40.4725 78.1529 37.6504C77.8172 34.8283 76.6343 32.1741 74.7601 30.0377Z"
          fill="white"
        />
        <path
          d="M34.5 47.125C36.1576 47.125 37.7473 46.4665 38.9194 45.2944C40.0915 44.1223 40.75 42.5326 40.75 40.875C40.75 39.2174 40.0915 37.6277 38.9194 36.4556C37.7473 35.2835 36.1576 34.625 34.5 34.625C32.8424 34.625 31.2527 35.2835 30.0806 36.4556C28.9085 37.6277 28.25 39.2174 28.25 40.875C28.25 42.5326 28.9085 44.1223 30.0806 45.2944C31.2527 46.4665 32.8424 47.125 34.5 47.125Z"
          fill="url(#paint5_linear_7859_64959)"
        />
        <path
          d="M59.5 47.125C61.1576 47.125 62.7473 46.4665 63.9194 45.2944C65.0915 44.1223 65.75 42.5326 65.75 40.875C65.75 39.2174 65.0915 37.6277 63.9194 36.4556C62.7473 35.2835 61.1576 34.625 59.5 34.625C57.8424 34.625 56.2527 35.2835 55.0806 36.4556C53.9085 37.6277 53.25 39.2174 53.25 40.875C53.25 42.5326 53.9085 44.1223 55.0806 45.2944C56.2527 46.4665 57.8424 47.125 59.5 47.125Z"
          fill="url(#paint6_linear_7859_64959)"
        />
        <g filter="url(#filter0_f_7859_64959)">
          <path
            d="M29.0312 12.75C29.0312 12.75 27.4688 22.125 16.5312 22.125"
            stroke="#4475BF"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter1_f_7859_64959)">
          <path
            d="M62.625 11.9688C62.625 11.9688 64.1875 21.3438 75.125 21.3438"
            stroke="#166CDE"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M29.8125 11.1875C29.8125 11.1875 28.25 20.5625 17.3125 20.5625"
          stroke="url(#paint7_linear_7859_64959)"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.8125 11.1875C29.8125 11.1875 28.25 20.5625 17.3125 20.5625"
          stroke="url(#paint8_radial_7859_64959)"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.1875 11.1875C64.1875 11.1875 65.75 20.5625 76.6875 20.5625"
          stroke="url(#paint9_radial_7859_64959)"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M62.3146 72.1436C62.6583 73.8374 61.2208 75.2499 59.4958 75.2499H34.4989C32.7739 75.2499 31.3427 73.8374 31.6833 72.1436C32.4037 68.6133 34.3216 65.4402 37.1125 63.1613C39.9034 60.8825 43.3959 59.6377 46.9989 59.6377C50.602 59.6377 54.0945 60.8825 56.8854 63.1613C59.6763 65.4402 61.5942 68.6133 62.3146 72.1436Z"
          fill="url(#paint10_radial_7859_64959)"
        />
        <path
          d="M15.75 51.8125C15.75 47.4978 12.2522 44 7.9375 44C3.62278 44 0.125 47.4978 0.125 51.8125V64.3125C0.125 68.6272 3.62278 72.125 7.9375 72.125C12.2522 72.125 15.75 68.6272 15.75 64.3125V51.8125Z"
          fill="url(#paint11_radial_7859_64959)"
        />
        <defs>
          <filter
            id="filter0_f_7859_64959"
            x="14.9062"
            y="11.125"
            width="15.75"
            height="12.625"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.5"
              result="effect1_foregroundBlur_7859_64959"
            />
          </filter>
          <filter
            id="filter1_f_7859_64959"
            x="61"
            y="10.3438"
            width="15.75"
            height="12.625"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.5"
              result="effect1_foregroundBlur_7859_64959"
            />
          </filter>
          <radialGradient
            id="paint0_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(76.688 22.1237) rotate(132.839) scale(117.198)"
          >
            <stop stop-color="#FFF478" />
            <stop offset="0.475" stop-color="#FFB02E" />
            <stop offset="1" stop-color="#F70A8D" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(47 147.125) rotate(-90) scale(159.375 203.115)"
          >
            <stop offset="0.67" stop-color="#BFB2DD" stop-opacity="0" />
            <stop offset="0.748" stop-color="#A4AEEB" />
            <stop offset="0.812" stop-color="#379EFF" />
            <stop offset="0.964" stop-color="#1345B7" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(53.25 37.75) rotate(135) scale(128.163)"
          >
            <stop offset="0.315" stop-opacity="0" />
            <stop offset="1" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(37.276 31.8478) rotate(135) scale(30.4449 15.7572)"
          >
            <stop offset="0.331" stop-color="#392108" />
            <stop offset="1" stop-color="#C87928" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(68.875 34.625) rotate(135) scale(25.4117 14.3453)"
          >
            <stop offset="0.402" stop-color="#392108" />
            <stop offset="1" stop-color="#C87928" stop-opacity="0" />
          </radialGradient>
          <linearGradient
            id="paint5_linear_7859_64959"
            x1="61.9031"
            y1="34.625"
            x2="59.5"
            y2="47.125"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#553B3E" />
            <stop offset="1" stop-color="#3D2432" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_7859_64959"
            x1="61.9031"
            y1="34.625"
            x2="59.5"
            y2="47.125"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#553B3E" />
            <stop offset="1" stop-color="#3D2432" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_7859_64959"
            x1="26.6875"
            y1="9.625"
            x2="26.6875"
            y2="14.3125"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.03" stop-color="#524049" />
            <stop offset="1" stop-color="#4A2C42" />
          </linearGradient>
          <radialGradient
            id="paint8_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(18.875 9.625) rotate(54.4623) scale(13.4411)"
          >
            <stop offset="0.542" stop-color="#493032" />
            <stop offset="0.807" stop-color="#5E445A" />
            <stop offset="0.955" stop-color="#4A2C42" />
          </radialGradient>
          <radialGradient
            id="paint9_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(75.1235 9.62777) rotate(125.538) scale(13.4411)"
          >
            <stop stop-color="#C2B4B5" />
            <stop offset="0.887" stop-color="#462B45" />
            <stop offset="1" stop-color="#4A2C42" />
          </radialGradient>
          <radialGradient
            id="paint10_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(46.9989 78.7218) rotate(-90) scale(23.7847 47.5694)"
          >
            <stop stop-color="#F70A8D" />
            <stop offset="1" stop-color="#89029C" />
          </radialGradient>
          <radialGradient
            id="paint11_radial_7859_64959"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13.1451 45.2783) rotate(104.88) scale(30.4236 11.5528)"
          >
            <stop stop-color="#5C98FF" />
            <stop offset="0.806" stop-color="#3D5BF1" />
            <stop offset="0.962" stop-color="#6065CA" />
          </radialGradient>
        </defs>
      </svg>
    );
  } else if (value === "good") {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 89 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint0_radial_7859_53882)"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint1_radial_7859_53882)"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint2_radial_7859_53882)"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint3_radial_7859_53882)"
          fill-opacity="0.6"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint4_radial_7859_53882)"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint5_radial_7859_53882)"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint6_radial_7859_53882)"
        />
        <path
          d="M44.4969 87.7437C73.6656 87.7437 88.2437 68.1562 88.2437 43.9937C88.2437 19.8375 73.6656 0.25 44.4937 0.25C15.3281 0.25 0.75 19.8375 0.75 43.9969C0.75 68.1562 15.325 87.7437 44.4969 87.7437Z"
          fill="url(#paint7_radial_7859_53882)"
        />
        <g filter="url(#filter0_f_7859_53882)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.9844 39.7093C34.0099 38.0928 35.483 35.8868 36.1998 33.3964C36.9166 30.906 36.8417 28.2544 35.9854 25.8085C35.129 23.3626 33.5337 21.2433 31.42 19.7439C29.3064 18.2444 26.779 17.439 24.1875 17.439C21.596 17.439 19.0686 18.2444 16.955 19.7439C14.8413 21.2433 13.246 23.3626 12.3896 25.8085C11.5333 28.2544 11.4584 30.906 12.1752 33.3964C12.892 35.8868 14.3651 38.0928 16.3906 39.7093C18.6219 38.9593 21.475 38.2718 24.1875 38.2718C26.9 38.2718 29.75 38.9593 31.9844 39.7093Z"
            fill="#B3671F"
          />
        </g>
        <g filter="url(#filter1_f_7859_53882)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M67.9219 38.928C69.9474 37.3116 71.4205 35.1055 72.1373 32.6152C72.8541 30.1248 72.7792 27.4732 71.9229 25.0273C71.0665 22.5813 69.4712 20.462 67.3575 18.9626C65.2439 17.4632 62.7165 16.6577 60.125 16.6577C57.5335 16.6577 55.0061 17.4632 52.8925 18.9626C50.7788 20.462 49.1835 22.5813 48.3271 25.0273C47.4708 27.4732 47.3959 30.1248 48.1127 32.6152C48.8295 35.1055 50.3026 37.3116 52.3281 38.928C54.5594 38.178 57.4125 37.4905 60.125 37.4905C62.8375 37.4905 65.6875 38.178 67.9219 38.928Z"
            fill="#9F5915"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.375 26.8125C41.3768 28.9252 40.9017 31.0111 39.9851 32.9147C39.0685 34.8182 37.7341 36.4903 36.0813 37.8063C33.5719 36.9625 30.3625 36.1875 27.3125 36.1875C24.2594 36.1875 21.0531 36.9625 18.5438 37.8063C16.6837 36.3226 15.2304 34.3913 14.3201 32.193C13.4097 29.9948 13.072 27.6015 13.3385 25.2371C13.6051 22.8728 14.4672 20.6147 15.8441 18.6743C17.2211 16.7339 19.0678 15.1746 21.2116 14.1424C23.3553 13.1101 25.7259 12.6387 28.1014 12.7722C30.477 12.9056 32.7799 13.6397 34.7945 14.9056C36.8091 16.1715 38.4695 17.9279 39.6204 20.0103C40.7713 22.0928 41.375 24.4332 41.375 26.8125ZM75.75 26.8125C75.7518 28.9252 75.2767 31.0111 74.3601 32.9147C73.4435 34.8182 72.1091 36.4903 70.4563 37.8063C67.9469 36.9625 64.7375 36.1875 61.6875 36.1875C58.6344 36.1875 55.4281 36.9625 52.9188 37.8063C51.0587 36.3226 49.6054 34.3913 48.695 32.193C47.7847 29.9948 47.447 27.6015 47.7135 25.2371C47.9801 22.8728 48.8422 20.6147 50.2191 18.6743C51.5961 16.7339 53.4428 15.1746 55.5866 14.1424C57.7303 13.1101 60.1009 12.6387 62.4764 12.7722C64.852 12.9056 67.1549 13.6397 69.1695 14.9056C71.1841 16.1715 72.8445 17.9279 73.9954 20.0103C75.1463 22.0928 75.75 24.4332 75.75 26.8125Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.25 26.8125C38.25 31.2938 35.9375 35.1469 32.6312 36.8375C30.8873 36.4277 29.1038 36.2098 27.3125 36.1875C26.3344 36.1875 25.3437 36.2656 24.3625 36.4031C21.4687 34.5438 19.5 30.9438 19.5 26.8125C19.5 20.7719 23.6969 15.875 28.875 15.875C34.0531 15.875 38.25 20.7719 38.25 26.8125ZM69.5 26.8125C69.5 30.9438 67.5344 34.5438 64.6375 36.4031C63.6602 36.264 62.6746 36.1919 61.6875 36.1875C59.9094 36.1875 58.0812 36.45 56.3688 36.8375C53.0594 35.1469 50.75 31.2938 50.75 26.8125C50.75 20.7719 54.9469 15.875 60.125 15.875C65.3031 15.875 69.5 20.7719 69.5 26.8125Z"
          fill="url(#paint8_linear_7859_53882)"
        />
        <path
          d="M44.5 72.125C16.375 72.125 16.375 44 16.375 44H72.625C72.625 44 72.625 72.125 44.5 72.125Z"
          fill="url(#paint9_radial_7859_53882)"
        />
        <path
          d="M19.5 45.5625V44H69.5V45.5625C69.5 46.3913 69.1708 47.1862 68.5847 47.7722C67.9987 48.3583 67.2038 48.6875 66.375 48.6875H22.625C21.7962 48.6875 21.0013 48.3583 20.4153 47.7722C19.8292 47.1862 19.5 46.3913 19.5 45.5625Z"
          fill="url(#paint10_linear_7859_53882)"
        />
        <defs>
          <filter
            id="filter0_f_7859_53882"
            x="9.6875"
            y="15.439"
            width="29"
            height="26.2705"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1"
              result="effect1_foregroundBlur_7859_53882"
            />
          </filter>
          <filter
            id="filter1_f_7859_53882"
            x="45.625"
            y="14.6577"
            width="29"
            height="26.2705"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1"
              result="effect1_foregroundBlur_7859_53882"
            />
          </filter>
          <radialGradient
            id="paint0_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(74.188 22.1237) rotate(132.839) scale(117.198)"
          >
            <stop stop-color="#FFF478" />
            <stop offset="0.475" stop-color="#FFB02E" />
            <stop offset="1" stop-color="#F70A8D" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(74.1838 22.127) rotate(131.878) scale(121.715)"
          >
            <stop stop-color="#FFF478" />
            <stop offset="0.475" stop-color="#FFB02E" />
            <stop offset="1" stop-color="#F70A8D" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(44.4978 33.0616) rotate(101.31) scale(55.7706 71.4316)"
          >
            <stop offset="0.788" stop-color="#F59639" stop-opacity="0" />
            <stop offset="0.973" stop-color="#FF7DCE" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(50.75 37.75) rotate(135) scale(128.163)"
          >
            <stop offset="0.315" stop-opacity="0" />
            <stop offset="1" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(44.4998 47.1274) rotate(77.692) scale(87.9591)"
          >
            <stop offset="0.508" stop-color="#7D6133" stop-opacity="0" />
            <stop offset="1" stop-color="#715B32" />
          </radialGradient>
          <radialGradient
            id="paint5_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(46.0625 45.5625) rotate(55.713) scale(41.6047 30.1573)"
          >
            <stop stop-color="#FFB849" />
            <stop offset="1" stop-color="#FFB847" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint6_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(58.5625 50.25) rotate(9.86582) scale(36.4769)"
          >
            <stop stop-color="#FFA64B" />
            <stop offset="0.9" stop-color="#FFAE46" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint7_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(49.1877 40.8759) rotate(43.971) scale(184.54)"
          >
            <stop offset="0.185" stop-opacity="0" />
            <stop offset="1" stop-opacity="0.4" />
          </radialGradient>
          <linearGradient
            id="paint8_linear_7859_53882"
            x1="63.7313"
            y1="15.875"
            x2="59.2625"
            y2="36.65"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#553B3E" />
            <stop offset="1" stop-color="#3D2432" />
          </linearGradient>
          <radialGradient
            id="paint9_radial_7859_53882"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(44.5 78.375) rotate(-90) scale(34.375 68.75)"
          >
            <stop stop-color="#F70A8D" />
            <stop offset="1" stop-color="#89029C" />
          </radialGradient>
          <linearGradient
            id="paint10_linear_7859_53882"
            x1="44.5"
            y1="44"
            x2="44.5"
            y2="48.6875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ECCDFF" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (value === "normal") {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 88 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint0_radial_7859_48524)"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint1_radial_7859_48524)"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint2_radial_7859_48524)"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint3_radial_7859_48524)"
          fill-opacity="0.6"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint4_radial_7859_48524)"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint5_radial_7859_48524)"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint6_radial_7859_48524)"
        />
        <path
          d="M43.9969 87.7437C73.1656 87.7437 87.7437 68.1562 87.7437 43.9937C87.7437 19.8375 73.1656 0.25 43.9937 0.25C14.8281 0.25 0.25 19.8375 0.25 43.9969C0.25 68.1562 14.825 87.7437 43.9969 87.7437Z"
          fill="url(#paint7_radial_7859_48524)"
        />
        <path
          d="M47.1172 29.9371C47.1172 31.784 47.481 33.6129 48.1877 35.3192C48.8945 37.0255 49.9305 38.5759 51.2365 39.8819C52.5424 41.1879 54.0928 42.2238 55.7992 42.9306C57.5055 43.6374 59.3343 44.0012 61.1813 44.0012C63.0282 44.0012 64.857 43.6374 66.5633 42.9306C68.2697 42.2238 69.8201 41.1879 71.126 39.8819C72.432 38.5759 73.468 37.0255 74.1748 35.3192C74.8815 33.6129 75.2453 31.784 75.2453 29.9371C75.2453 26.2071 73.7636 22.6298 71.126 19.9923C68.4885 17.3548 64.9113 15.873 61.1813 15.873C57.4512 15.873 53.874 17.3548 51.2365 19.9923C48.5989 22.6298 47.1172 26.2071 47.1172 29.9371ZM40.8703 29.9371C40.8703 33.6671 39.3886 37.2444 36.751 39.8819C34.1135 42.5194 30.5363 44.0012 26.8062 44.0012C23.0762 44.0012 19.499 42.5194 16.8615 39.8819C14.2239 37.2444 12.7422 33.6671 12.7422 29.9371C12.7422 26.2075 14.2238 22.6307 16.861 19.9934C19.4982 17.3562 23.0751 15.8746 26.8047 15.8746C30.5343 15.8746 34.1111 17.3562 36.7484 19.9934C39.3856 22.6307 40.8703 26.2075 40.8703 29.9371Z"
          fill="white"
        />
        <path
          d="M28.75 39.9062C31.4105 39.9062 33.9619 38.8494 35.8432 36.9682C37.7244 35.0869 38.7812 32.5355 38.7812 29.875C38.7812 27.2145 37.7244 24.6631 35.8432 22.7818C33.9619 20.9006 31.4105 19.8438 28.75 19.8438C26.0895 19.8438 23.5381 20.9006 21.6568 22.7818C19.7756 24.6631 18.7188 27.2145 18.7188 29.875C18.7188 32.5355 19.7756 35.0869 21.6568 36.9682C23.5381 38.8494 26.0895 39.9062 28.75 39.9062ZM59.2406 39.9062C56.5802 39.9062 54.0287 38.8494 52.1475 36.9682C50.2662 35.0869 49.2094 32.5355 49.2094 29.875C49.2094 27.2145 50.2662 24.6631 52.1475 22.7818C54.0287 20.9006 56.5802 19.8438 59.2406 19.8438C61.9011 19.8438 64.4526 20.9006 66.3338 22.7818C68.215 24.6631 69.2719 27.2145 69.2719 29.875C69.2719 32.5355 68.215 35.0869 66.3338 36.9682C64.4526 38.8494 61.9011 39.9062 59.2406 39.9062Z"
          fill="#3F2931"
        />
        <path
          d="M58.2807 49.7587L28.1299 58.1622C26.5588 58.6001 25.6401 60.2287 26.078 61.7998L26.0789 61.8028C26.5167 63.3739 28.1453 64.2925 29.7164 63.8546L59.8672 55.4511C61.4383 55.0132 62.357 53.3846 61.9191 51.8136L61.9182 51.8105C61.4803 50.2395 59.8517 49.3208 58.2807 49.7587Z"
          fill="url(#paint8_linear_7859_48524)"
        />
        <path
          d="M58.2807 49.7587L28.1299 58.1622C26.5588 58.6001 25.6401 60.2287 26.078 61.7998L26.0789 61.8028C26.5167 63.3739 28.1453 64.2925 29.7164 63.8546L59.8672 55.4511C61.4383 55.0132 62.357 53.3846 61.9191 51.8136L61.9182 51.8105C61.4803 50.2395 59.8517 49.3208 58.2807 49.7587Z"
          fill="url(#paint9_linear_7859_48524)"
        />
        <path
          d="M58.2807 49.7587L28.1299 58.1622C26.5588 58.6001 25.6401 60.2287 26.078 61.7998L26.0789 61.8028C26.5167 63.3739 28.1453 64.2925 29.7164 63.8546L59.8672 55.4511C61.4383 55.0132 62.357 53.3846 61.9191 51.8136L61.9182 51.8105C61.4803 50.2395 59.8517 49.3208 58.2807 49.7587Z"
          fill="url(#paint10_radial_7859_48524)"
        />
        <g filter="url(#filter0_f_7859_48524)">
          <path
            d="M28.8594 60.4467L59.3781 51.9404"
            stroke="#5C4B51"
            stroke-width="0.3"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_7859_48524"
            x="28.2203"
            y="51.1959"
            width="31.7977"
            height="9.99492"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.3"
              result="effect1_foregroundBlur_7859_48524"
            />
          </filter>
          <radialGradient
            id="paint0_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(73.688 22.1237) rotate(132.839) scale(117.198)"
          >
            <stop stop-color="#FFF478" />
            <stop offset="0.475" stop-color="#FFB02E" />
            <stop offset="1" stop-color="#F70A8D" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(73.6838 22.127) rotate(131.878) scale(121.715)"
          >
            <stop stop-color="#FFF478" />
            <stop offset="0.475" stop-color="#FFB02E" />
            <stop offset="1" stop-color="#F70A8D" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(43.9978 33.0616) rotate(101.31) scale(55.7706 71.4316)"
          >
            <stop offset="0.788" stop-color="#F59639" stop-opacity="0" />
            <stop offset="0.973" stop-color="#FF7DCE" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(50.25 37.75) rotate(135) scale(128.163)"
          >
            <stop offset="0.315" stop-opacity="0" />
            <stop offset="1" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(43.9998 47.1274) rotate(77.692) scale(87.9591)"
          >
            <stop offset="0.508" stop-color="#7D6133" stop-opacity="0" />
            <stop offset="1" stop-color="#715B32" />
          </radialGradient>
          <radialGradient
            id="paint5_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(45.5625 45.5625) rotate(55.713) scale(41.6047 30.1573)"
          >
            <stop stop-color="#FFB849" />
            <stop offset="1" stop-color="#FFB847" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint6_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(58.0625 50.25) rotate(9.86582) scale(36.4769)"
          >
            <stop stop-color="#FFA64B" />
            <stop offset="0.9" stop-color="#FFAE46" stop-opacity="0" />
          </radialGradient>
          <radialGradient
            id="paint7_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.6877 40.8759) rotate(43.971) scale(184.54)"
          >
            <stop offset="0.185" stop-opacity="0" />
            <stop offset="1" stop-opacity="0.4" />
          </radialGradient>
          <linearGradient
            id="paint8_linear_7859_48524"
            x1="43.2053"
            y1="53.9605"
            x2="44.5821"
            y2="58.9003"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4B383A" />
            <stop offset="1" stop-color="#53265D" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_7859_48524"
            x1="26.078"
            y1="61.7998"
            x2="29.4646"
            y2="60.8559"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#503333" />
            <stop offset="1" stop-color="#503333" stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint10_radial_7859_48524"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(61.6641 50.3236) rotate(144.953) scale(4.92063 3.84056)"
          >
            <stop stop-color="#605052" />
            <stop offset="1" stop-color="#605052" stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
    );
  }
};

export const getNotPlan = (checked = false) => {
  if (checked) {
    return "(ยังไม่ได้วางแผน)";
  }
  return "";
};
